
export const NAV_CLASS = 'blue lighten-2';
export const NAV_BG_COLOR = '#311b92';
export const NAV_TEXT_COLOR = '#698497';
export const NAVITEM_CLASS = 'pink accent-3';



// WEBPACK FOOTER //
// ./src/constants/layout.js